import { REDIRECT_WHITELIST_REGEX } from "@constants/redirect-whitelist";
import { CLIENT_CONFIGURATION } from "@constants/ulm-constants";
import { UlmClientType } from "@custom-types/ulm-types";
import { UlmRedirectMessage } from "@faro-lotv/gate-keepers";
import { BrowserUtils } from "@stellar/utils";

/**
 * Sends a message to the parent window with the redirect URL
 *
 * @param redirectUrl Redirect URL
 */
export function requestParentToRedirect(redirectUrl: URL): void {
  const message: UlmRedirectMessage = {
    identifier: "UlmRedirectMessage",
    redirectUrl: redirectUrl.href,
  };

  window.parent.postMessage(message, "*");
}

/**
 * @returns whether the origin of the passed URL is valid according to the redirect whitelist.
 *
 * @param url URL string.
 */
export function isValidRedirectUrl(url: string): boolean {
  try {
    const urlOrigin = new URL(url).origin;
    return REDIRECT_WHITELIST_REGEX.some((regex) => regex.test(urlOrigin));
  } catch (_error) {
    return false;
  }
}

/**
 * @returns whether the ULM is embedded in the passed client.
 * It checks both if the client configuration indicates that it is embedded
 * and if the current browser context is inside an iframe.
 * @param client ULM client.
 */
export function isEmbedded(client: UlmClientType): boolean {
  return CLIENT_CONFIGURATION[client].isEmbedded && BrowserUtils.isInIframe();
}
